(function () {
  'use strict';

  var cfg      = window.__TLC_CHAT_CONFIG__ || {};
  var API_BASE = (cfg.apiUrl || 'https://zooming-fulfillment-production-aa48.up.railway.app');
  var API_URL  = API_BASE + '/api/chat';
  var CAT_URL  = API_BASE + '/api/products';
  var POLL_URL = API_BASE + '/api/chat/poll';

  var isOpen          = false;
  var isLoading       = false;
  var messages        = [];
  var catalog         = {}; // handle → { imageUrl, price, variantId }
  var catalogLoaded   = false;
  var catalogLoading  = false;
  var chipsUsed       = false; // hide chips after first interaction

  // ── Stable session id (persisted once per shopper) ──────────────────────────
  var sessionId;
  try {
    sessionId = window.localStorage.getItem('tlc_chat_sid');
    if (!sessionId) {
      sessionId = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : (Date.now() + '-' + Math.random().toString(16).slice(2));
      window.localStorage.setItem('tlc_chat_sid', sessionId);
    }
  } catch (e) {
    sessionId = Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  // ── Live-takeover (human agent) state ───────────────────────────────────────
  var pollTimer  = null;   // setInterval handle (null when not polling)
  var isHandoff  = false;  // true while a human agent is handling this chat
  var handoffShown = false; // "chatting with our team" pill rendered
  var handoffRequested = false; // shopper already asked for the team this session
  var lastAgentId = '';    // highest agent message id already rendered
  try {
    var storedAgentId = window.localStorage.getItem('tlc_chat_last_agent');
    if (storedAgentId) lastAgentId = storedAgentId;
  } catch (e) {}

  var btn      = document.getElementById('tlc-chat-btn');
  var panel    = document.getElementById('tlc-chat-panel');
  var closeBtn = document.getElementById('tlc-chat-close');
  var input    = document.getElementById('tlc-chat-input');
  var sendBtn  = document.getElementById('tlc-chat-send');
  var msgList  = document.getElementById('tlc-chat-messages');
  var prodRow  = document.getElementById('tlc-chat-products');
  var chipsEl  = document.getElementById('tlc-chat-chips');
  var nudge    = document.getElementById('tlc-chat-nudge');
  var avatarEl = document.getElementById('tlc-chat-avatar');

  if (!btn || !panel || !closeBtn || !input || !sendBtn || !msgList || !prodRow) return;

  // ── Avatar ──────────────────────────────────────────────────────────────────
  if (avatarEl && cfg.avatarUrl) {
    avatarEl.src = cfg.avatarUrl;
  }

  // ── Nudge: show after 6s, auto-hide after 6 more ────────────────────────────
  setTimeout(function () {
    if (nudge && !isOpen) nudge.removeAttribute('aria-hidden');
    setTimeout(function () {
      if (nudge) {
        nudge.setAttribute('aria-hidden', 'true');
        nudge.style.display = 'none';
      }
    }, 6000);
  }, 6000);

  // ── Quick-reply chips ────────────────────────────────────────────────────────
  var DEFAULT_CHIPS = ['Find my scent', 'Show bestsellers', 'Gift ideas'];
  var PRODUCT_CHIPS = ['What makes this special?', 'Is this right for my skin?', 'How do I use it?'];

  function renderChips() {
    if (!chipsEl || chipsUsed) return;
    var isProduct = cfg.pageType === 'product' && cfg.productTitle;
    var labels = isProduct ? PRODUCT_CHIPS : DEFAULT_CHIPS;
    while (chipsEl.firstChild) chipsEl.removeChild(chipsEl.firstChild);
    labels.forEach(function (label) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'tlc-chat__chip';
      chip.textContent = label;
      chip.addEventListener('click', function () {
        input.value = label;
        hideChips();
        sendMessage();
      });
      chipsEl.appendChild(chip);
    });
  }

  function hideChips() {
    chipsUsed = true;
    if (chipsEl) {
      while (chipsEl.firstChild) chipsEl.removeChild(chipsEl.firstChild);
    }
  }

  // ── Catalog ──────────────────────────────────────────────────────────────────
  function loadCatalog() {
    if (catalogLoading || catalogLoaded) return;
    catalogLoading = true;
    fetch(CAT_URL)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (items) {
        catalogLoaded = true;
        if (!items) return;
        items.forEach(function (item) {
          if (item.handle) catalog[item.handle] = item;
        });
      })
      .catch(function () { catalogLoaded = true; });
  }

  // ── Panel open/close ─────────────────────────────────────────────────────────
  function openChat() {
    isOpen = true;
    panel.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    if (nudge) nudge.style.display = 'none';
    if (!catalogLoaded) loadCatalog();
    renderChips();
    startPolling();
    input.focus();
  }

  function closeChat() {
    isOpen = false;
    panel.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    stopPolling();
    btn.focus();
  }

  btn.addEventListener('click', function () { isOpen ? closeChat() : openChat(); });
  closeBtn.addEventListener('click', closeChat);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeChat();
  });

  // ── Message rendering ────────────────────────────────────────────────────────
  function makeMsg(role) {
    var div = document.createElement('div');
    div.className = 'tlc-chat__msg tlc-chat__msg--' + (role === 'user' ? 'user' : 'bot');
    var p = document.createElement('p');
    div.appendChild(p);
    msgList.appendChild(div);
    msgList.scrollTop = msgList.scrollHeight;
    return { div: div, p: p };
  }

  // ── Agent (human team) bubble ───────────────────────────────────────────────
  function makeAgentMsg(authorName, content) {
    var div = document.createElement('div');
    div.className = 'tlc-chat__msg tlc-chat__msg--agent';

    var label = document.createElement('span');
    label.className = 'tlc-chat__agent-name';
    label.textContent = authorName || 'TLC Team';
    div.appendChild(label);

    var p = document.createElement('p');
    p.textContent = content == null ? '' : String(content);
    div.appendChild(p);

    msgList.appendChild(div);
    msgList.scrollTop = msgList.scrollHeight;
  }

  function showHandoffNote(text) {
    var note = document.createElement('div');
    note.className = 'tlc-chat__handoff-note';
    note.textContent = text;
    msgList.appendChild(note);
    msgList.scrollTop = msgList.scrollHeight;
  }

  // In-chat handoff confirmation + a quiet WhatsApp fallback (never auto-opened).
  function showHandoffRequestedNote() {
    showHandoffNote("Our care team has been looped in — they'll reply right here 💬");
    var note = document.createElement('div');
    note.className = 'tlc-chat__handoff-note';
    note.appendChild(document.createTextNode('Prefer WhatsApp instead? '));
    var a = document.createElement('a');
    a.href = 'https://wa.me/917404055560';
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = 'Chat with us there';
    note.appendChild(a);
    msgList.appendChild(note);
    msgList.scrollTop = msgList.scrollHeight;
  }

  // ── Poll loop for human-agent replies + handoff state ───────────────────────
  function pollAgentMessages() {
    var url = POLL_URL + '?sessionId=' + encodeURIComponent(sessionId) +
              '&after=' + encodeURIComponent(lastAgentId || '');
    fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (resp) {
        if (!resp) return;

        if (resp.handoff === true) {
          isHandoff = true;
          if (!handoffShown) {
            handoffShown = true;
            showHandoffNote("You're chatting with our team 💬");
          }
        } else if (resp.handoff === false && isHandoff) {
          isHandoff = false;
          handoffShown = false;
          showHandoffNote('Aira is back ✨');
        }

        var list = (resp && resp.messages) ? resp.messages : [];
        if (!list || !list.length) return;

        var i, m;
        for (i = 0; i < list.length; i++) {
          m = list[i];
          if (!m || m.role !== 'agent') continue;
          var mid = (m.id == null) ? '' : String(m.id);
          if (!mid || mid === lastAgentId) continue;

          makeAgentMsg(m.authorName, m.content);
          lastAgentId = mid;
          try {
            window.localStorage.setItem('tlc_chat_last_agent', lastAgentId);
          } catch (e) {}
        }
      })
      .catch(function () { /* never break the widget */ });
  }

  function startPolling() {
    if (pollTimer) return;
    pollAgentMessages();
    pollTimer = window.setInterval(pollAgentMessages, 5000);
  }

  function stopPolling() {
    if (pollTimer) {
      window.clearInterval(pollTimer);
      pollTimer = null;
    }
  }

  function extractProducts(text) {
    var match = text.match(/```json\s*([\s\S]*?)\s*```/);
    if (!match) return null;
    try {
      var data = JSON.parse(match[1]);
      return Array.isArray(data.products) ? data.products : null;
    } catch (e) { return null; }
  }

  function cleanText(text) {
    return text
      .replace(/```json[\s\S]*?```/g, '')
      .replace(/\[WHATSAPP_HANDOFF\]/g, '')
      // Silent name tag Aira emits once — strip complete token, and also any
      // partial tag still streaming in (e.g. "[[NAME: Me") so it never flashes.
      .replace(/\[\[NAME:[^\]]*\]\]/g, '')
      .replace(/\[\[(?:N(?:A(?:M(?:E(?::[^\]]*)?)?)?)?)?$/, '')
      .trim();
  }

  function thumbUrl(src) {
    if (!src) return null;
    return src.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?|$)/i, '_240x$1$2');
  }

  // ── Product cards ─────────────────────────────────────────────────────────────
  function renderProducts(products) {
    while (prodRow.firstChild) prodRow.removeChild(prodRow.firstChild);
    prodRow.hidden = products.length === 0;

    products.forEach(function (item) {
      var title  = String(item.title  || '');
      var handle = String(item.handle || '');
      var reason = String(item.reason || '');

      if (!/^[a-z0-9-]+$/.test(handle)) return;

      var info      = catalog[handle] || {};
      var imageUrl  = info.imageUrl  || null;
      var price     = (info.price != null) ? info.price : null;
      var variantId = info.variantId || null;

      var card = document.createElement('div');
      card.className = 'tlc-chat__product-card';

      if (imageUrl) {
        var img = document.createElement('img');
        img.className = 'tlc-chat__product-card__img';
        img.src = thumbUrl(imageUrl);
        img.alt = title;
        img.loading = 'lazy';
        img.width = 140;
        img.height = 140;
        card.appendChild(img);
      }

      var body = document.createElement('div');
      body.className = 'tlc-chat__product-card__body';

      var nameEl = document.createElement('p');
      nameEl.className = 'tlc-chat__product-card__name';
      nameEl.textContent = title;

      var reasonEl = document.createElement('p');
      reasonEl.className = 'tlc-chat__product-card__reason';
      reasonEl.textContent = reason;

      body.appendChild(nameEl);
      body.appendChild(reasonEl);

      if (price != null) {
        var priceEl = document.createElement('p');
        priceEl.className = 'tlc-chat__product-card__price';
        priceEl.textContent = price;
        body.appendChild(priceEl);
      }

      var atcBtn = document.createElement('button');
      atcBtn.type = 'button';
      atcBtn.className = 'tlc-chat__product-card__atc';
      atcBtn.textContent = 'Add to bag';
      atcBtn.setAttribute('data-handle', handle);
      atcBtn.addEventListener('click', function () {
        addToCart(handle, atcBtn, variantId);
      });

      body.appendChild(atcBtn);
      card.appendChild(body);
      prodRow.appendChild(card);
    });
  }

  // ── Add to cart ───────────────────────────────────────────────────────────────
  function addToCart(handle, atcBtn, variantId) {
    atcBtn.disabled = true;
    atcBtn.textContent = 'Adding…';

    var doAdd = function (id) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 }),
      }).then(function (r) {
        if (!r.ok) throw new Error('cart add failed');
        atcBtn.classList.add('is-done');
        atcBtn.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
    };

    if (variantId) {
      doAdd(variantId).catch(function () {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to bag';
      });
    } else {
      fetch('/products/' + handle + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('product not found');
          return r.json();
        })
        .then(function (product) {
          var variant = product.variants && product.variants[0];
          if (!variant) throw new Error('no variant');
          return doAdd(variant.id);
        })
        .catch(function () {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to bag';
        });
    }
  }

  // ── Send message ──────────────────────────────────────────────────────────────
  function sendMessage() {
    var text = input.value.trim();
    if (!text || isLoading) return;

    hideChips();
    input.value      = '';
    isLoading        = true;
    sendBtn.disabled = true;

    messages.push({ role: 'user', content: text });
    makeMsg('user').p.textContent = text;

    var bot = makeMsg('bot');
    if (!isHandoff) bot.div.classList.add('is-typing');

    var fullText = '';

    fetch(API_URL, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        messages: messages,
        sessionId: sessionId,
        context: {
          pageType:        cfg.pageType        || 'unknown',
          productTitle:    cfg.productTitle    || '',
          collectionTitle: cfg.collectionTitle || '',
        },
      }),
    })
    .then(function (res) {
      if (!res.ok) throw new Error('API error ' + res.status);
      var reader  = res.body.getReader();
      var decoder = new TextDecoder();

      function read() {
        return reader.read().then(function (chunk) {
          if (chunk.done) {
            var tail = decoder.decode();
            if (tail) {
              fullText += tail;
              bot.p.textContent = cleanText(fullText);
            }
            return;
          }
          fullText += decoder.decode(chunk.value, { stream: true });
          bot.p.textContent = cleanText(fullText);
          msgList.scrollTop = msgList.scrollHeight;
          return read();
        });
      }
      return read();
    })
    .then(function () {
      bot.div.classList.remove('is-typing');

      // In-chat takeover instead of bouncing the shopper out to WhatsApp:
      // the turn was already emitted to AONE with handoff=true (team pinged),
      // and the 5s poll renders agent replies right here in the panel.
      if (fullText.includes('[WHATSAPP_HANDOFF]') && !handoffRequested && !isHandoff) {
        handoffRequested = true;
        showHandoffRequestedNote();
        startPolling();
      }

      var products = extractProducts(fullText);
      if (products && products.length) {
        renderProducts(products);
      } else {
        prodRow.hidden = true;
        while (prodRow.firstChild) prodRow.removeChild(prodRow.firstChild);
      }

      messages.push({ role: 'assistant', content: cleanText(fullText) });
    })
    .catch(function () {
      bot.div.classList.remove('is-typing');
      bot.p.textContent = 'Something went wrong. Please try again.';
    })
    .finally(function () {
      isLoading        = false;
      sendBtn.disabled = false;
      input.focus();
    });
  }

  sendBtn.addEventListener('click', sendMessage);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  });

  // Footer "Talk to a human" — requests the in-chat team takeover (the message
  // routes through Aira, lands in AONE, and the team replies in this panel).
  var humanBtn = document.getElementById('tlc-chat-human');
  if (humanBtn) {
    humanBtn.addEventListener('click', function () {
      if (isHandoff || handoffRequested) {
        showHandoffNote("The team is already looped in — they'll reply right here 💬");
        return;
      }
      input.value = "I'd like to talk to a human, please.";
      sendMessage();
    });
  }

})();
